import * as z from "zod";

export const getAskRedoEmergencyMode = {
  name: "getAskRedoEmergencyMode" as const,
  input: z.object({}),
  output: z.object({
    emergencyMode: z.object({ enabled: z.boolean(), message: z.string() }),
  }),
};
